<template lang="pug">
.webhook-events-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    // - mobile card table
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .position-relative
        .mb-1.text-overflow-ellipse(style='width: 90%') 
          span.text {{ item.event_type }}
        .mb-1
          span.text.me-2 {{ $t('pages.webhookEventsCardTable.summary') }}:
          span.text.me-2 {{ item.summary }}
        .mb-1 {{ $t('pages.webhookEventsCardTable.sentDate') }}: {{ item.created_at | dateTime }}
        .mb-1
          span.text.me-2 {{ $t('pages.webhookEventsCardTable.lastResponse') }}:
          span.text.me-2 {{ $t(item.status) }}
        .mb-1
          span.text.me-2 {{ $t('pages.webhookEventsCardTable.attempts') }}:
          span.text.me-2 {{ $t(item.request.attempt) }}
        button(
          :aria-controls='`collapse-card-${index}`'
          :data-bs-target='`#collapse-card-${index}`'
          aria-expanded='false'
          data-bs-toggle='collapse'
          style='position: absolute; bottom: 0; right: -0.5rem'
          type='button'
        )
          icon.icon--blue(name='ellipsis-vertical')
        button(@click='retryWebhookEvent(item.uuid)' type='button')
          icon.icon--blue(name='share-from-square') 

      .collapse.collapse-card(
        :id='`collapse-card-${index}`'
        data-bs-parent='.webhook-events-card-table'
      )
        .collapse-card-block.mt-2.pt-2.border-top
          span.text
            strong {{ $t('pages.webhookEventsCardTable.lastResponse') }}:
          ul.m-0.list-unstyled
            li
              span.text
                strong {{ $t('pages.webhookEventsCardTable.status') }}:
              |
              IconStatus.ms-2(:iconStatus='getIconStatus(item.event_type)')
              span.text.ms-1 {{ item.status }}
            li
              span.text
                strong {{ $t('pages.webhookEventsCardTable.event') }}:
              span.text.ms-1 {{ item.event_type }}
            li
              span.text
                strong {{ $t('pages.webhookEventsCardTable.response') }}:
              span.text.ms-1d-inline-block.text-break {{ item.request.response_body }}

    // - card table desktop            
    template(v-slot:table-head)
      th(style='width: 5%') {{ $t('pages.webhookEventsCardTable.summary') }}
      th(style='width: 33%') {{ $t('pages.webhookEventsCardTable.lastResponse') }}
      th(style='width: 17%')
        .d-flex 
          span.text {{ $t('pages.webhookEventsCardTable.sentDate') }}
          button(
            @click='addSort("created_at", "DESC")'
            style='margin-top: -2px'
            v-show='sort.created_at === "ASC"'
          )
            icon.icon--blue(name='angle-down')
          button(
            @click='addSort("created_at", "ASC")'
            style='margin-top: -2px'
            v-show='sort.created_at !== "ASC"'
          )
            icon.icon--blue(name='angle-up')
      th(style='width: 24%')
        span.text {{ $t('pages.webhookEventsCardTable.attempts') }}
      th(style='width: 1%')
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      .d-table-row
        td
          .icon-text-wrapper
            span.text.ms-2 {{ item.summary }}
        td
          .webhook-events-card-table__name.text-overflow-ellipse(
            :title='item.summary'
          ) {{ item.status }}
        td {{ item.created_at | dateTime }}
        td
          span.text.me-2 {{ $t(item.request.attempt) }}
        td
          .d-flex
            button(
              :aria-controls='`collapse-row-${index}`'
              :data-bs-target='`#collapse-row-${index}`'
              aria-expanded='false'
              data-bs-toggle='collapse'
              type='button'
            )
              icon.icon--blue(name='ellipsis-vertical')
            button(@click='retryWebhookEvent(item.uuid)' type='button')
              icon.icon--blue(name='share-from-square')

      .d-table-row
        td.collapse-row.p-0(colspan='6')
          .collapse.collapse-row-block(
            :id='`collapse-row-${index}`'
            data-bs-parent='.webhook-events-card-table'
          )
            .p-3
              span.text.ms-2
                strong {{ $t('pages.webhookEventsCardTable.lastResponse') }}:
              ul.ms-4.list-unstyled
                li
                  span.text
                    strong {{ $t('pages.webhookEventsCardTable.status') }}:
                  |
                  IconStatus.ms-2(:iconStatus='getIconStatus(item.event_type)')
                  span.text.ms-1 {{ item.status }}
                li
                  span.text
                    strong {{ $t('pages.webhookEventsCardTable.event') }}:
                  span.text.ms-1 {{ item.event_type }}
                li
                  span.text
                    strong {{ $t('pages.webhookEventsCardTable.response') }}:
                  span.text.ms-1d-inline-block.text-break {{ item.request.response_body }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import EnvelopeSignaturesProgress from '@/ui/molecules/EnvelopeSignaturesProgress.vue';
import RecipientsLoader from '@/ui/molecules/RecipientsLoader.vue';
import IconEnviromentEnvelope from '@/ui/atoms/IconEnviromentEnvelope.vue';
import WebhooksEventsService from '@/services/WebhooksEventsService';
import alert from '@/modules/account/common/alert';
export default {
  name: 'WebhookEventsCardTable',
  components: {
    Icon,
    IconStatus,
    CardTable,
    EnvelopeSignaturesProgress,
    RecipientsLoader,
    IconEnviromentEnvelope,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sort: {
        created_at: '',
      },
    };
  },
  methods: {
    async retryWebhookEvent(eventId) {
      this.$loading(true);
      const webhookId = this.$route.params.webhookId;
      await WebhooksEventsService.retryEvent(webhookId, eventId)
        .then(() => {
          alert.fireAlert(
            this.$t('pages.manageWebhookEvents.retry.successMessage'),
            {
              classes: 'alert-success',
              styles:
                'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
              icon: 'circle-check',
            }
          );
          this.$emit('refresh');
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    getIconStatus(eventType) {
      const status = eventType.split('.').pop();
      if (status !== 'draft' && status !== 'template') {
        return status;
      }
      return 'in-transit';
    },
    addSort(column, type) {
      this.sort[column] = type;
      this.$emit('sort', {
        column: `${column}`,
        desc: type === 'DESC',
      });
    },
  },
};
</script>
<style scoped lang="stylus"></style>
